import { createContext, useContext } from 'react'

export const EditModeContext = createContext(false)

export const useEditMode = (): boolean => useContext(EditModeContext)
